
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Ref} from 'vue-property-decorator';
import {QChip} from 'quasar';
import ScoreAnimation from '../parts/ScoreAnimation.vue';

@Component({
  components: {ScoreAnimation},
})
export default class ScoreIndicator extends Vue {
  @Prop({default: 0, required: true}) score!: number;
  @Prop({default: 0, required: true}) scoreDiff!: number;
  @Prop({default: false, required: false}) noAnimation!: boolean;
  @Prop({default: false, required: false}) cardHackForAnimation!: boolean;
  @Prop({default: false}) absoluteBottomRight!: boolean;

  @Ref() scoreChip: QChip;
  @Ref() scoreSpan: HTMLSpanElement;

  scorePosition: {top: number; left: number} = {top: -1, left: 0};

  mounted() {
    // For strange reason need to wait before offsetTop is well calculated
    if (this.scoreChip) {
      setTimeout(() => {
        this.scorePosition = {
          top: this.scoreChip.$el.offsetTop,
          left: this.scoreChip.$el.offsetLeft,
        };
      }, 250);
    }
  }

  get colorChip() {
    if (this.scoreDiff > 0 && !this.noAnimation) {
      return this.getChipColorBasedOnScore(0);
    }
    return this.getChipColorBasedOnScore(this.score);
  }

  updateScoreBackgroundColor(score: number) {
    this.scoreChip?.$el.style.background = this.getChipColorBasedOnScore(score);
  }
  getChipColorBasedOnScore(score: number) {
    if (score === 0) {
      return 'rgb(255, 255, 255)';
    } else if (score < 40) {
      // linear-gradient(0deg, rgb(255,255,255), rgb(255,214,31)
      return `rgb(255, ${235 - (score * 20) / 40}, ${235 - (score * 200) / 39})`;
    } else if (score < 60) {
      // linear-gradient(0deg, rgb(255,214,31), rgb(167,224,54))
      return `rgb(${255 - ((score - 40) * 90) / 19}, 220, ${35 + ((score - 40) * 20) / 39})`;
    } else {
      // linear-gradient(0deg, rgb(167,224,54), rgba(27,196,61))
      return `rgb(${167 - ((score - 60) * 140) / 39}, ${220 - ((score - 60) * 30) / 39}, 55)`;
    }
  }

  get textColor() {
    if (this.score >= 100) {
      return 'white';
    }
    return 'dark';
  }
}
